import React from "react";
import Typography from "../../../Typography";
// import MemberCard from "../../components/MemberCard";
import MemberCardT2 from "../../components/MemberCardT2";

export default function OurTeam() {
  return (
    <div className="relative overflow-hidden bg-white">
      <div className="wrapper max-xsm:py-[50px] max-sm:py-[30px] max-md:py-[50px] py-[70px]">
        {/* <img
          className="absolute left-[-600px] opacity-10 top-0 min-w-[1400px]"
          src="./imgs/icons/illustration1.svg"
        ></img> */}
        <Typography.Subt className="z-1 relative text-center">
          Our Team
        </Typography.Subt>
        <Typography.P className="m-auto max-w-[870px] mt-[20px] opacity-80 text-center">
          Alphen has a team of talented and highly creative artists whose main
          goal is not only to please you but also to impress you with unique art
          that will help you stand out from the crowd.
        </Typography.P>
        {/* <MemberCard /> */}
      </div>
      <MemberCardT2 />
    </div>
  );
}
